import type { GetApiV1RefundsEligibilityOrderId200AllOf } from './getApiV1RefundsEligibilityOrderId200AllOf';
import type { GetApiV1RefundsEligibilityOrderId200AllOfThree } from './getApiV1RefundsEligibilityOrderId200AllOfThree';

export type GetApiV1RefundsEligibilityOrderId200 = GetApiV1RefundsEligibilityOrderId200AllOf & GetApiV1RefundsEligibilityOrderId200AllOfThree;
